export const tokenWithDecimalsPattern = (decimals: number) => {
  return new RegExp(`^\\d+(\\.\\d{0,${decimals}})?$`)
}
export const percentagePattern = new RegExp(/^(100(\.0{0,2})?|([1-9]?\d|0)(\.\d{0,2})?)$/g)
export const lockTimePattern = new RegExp(/^(?:[0-9]|[0-9]\d|10[0-4])$/)
export const emailPattern = new RegExp("^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$")
